import React, { FC } from 'react'

import { TasksPageBox } from './styled'
import TasksPageWrapper from './TasksPageWrapper'
import TasksHeader from './TasksHeader/TasksHeader'
import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { useTypedSelector } from '../../../../hooks/useTypedSelector'
import { getPatientsList } from '../../../../store/reducers/patients/actions'
import { selectRequestPatientFilterResult } from '../../../../store/reducers/patients/selectors'

const Tasks: FC = () => {
	const dispatch = useAppDispatch()
	const dataBodyParameters = useTypedSelector(
		selectRequestPatientFilterResult
	)

	React.useEffect(() => {
		dispatch(getPatientsList(dataBodyParameters))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<TasksPageBox>
			<TasksHeader />

			<TasksPageWrapper />
		</TasksPageBox>
	)
}

export default Tasks
